import React from "react";
import "./style.scss";
import CustomerReviewSearchPeriod from "../CustomerReviewSearchPeriod";
import {getCurrencyIcons, ReportAction, ReportType} from "../../../utils/enums";
import FilterTriggerControl from "../FilterTriggerControl/index.js";
import ExportFileControl from "../ExportFileControl/ExportFileControl.jsx";
import { GET_SALES_STATISTICS_EXCEL } from "../../../store/reducers/restaurant/restaurant-actions.js";

const CustomerSalesChartHeader = ({ filter, setFilterOpen, onSetFilter, title, currency, filterQuantity, items }) => {
    return (
        <div className={"customerSalesChartHeader"}>
            <div className={"title"}>
                {title || "N/A"}
                <div className={'salesFilters'}>
                    <ExportFileControl canSavePdfReport model={{filter, items}} control={{reportType: ReportType.Sales, reportAction: ReportAction.Get, action: GET_SALES_STATISTICS_EXCEL}} hideText horizontal />
                    <FilterTriggerControl filterCounter={filterQuantity} onClick={() => setFilterOpen(true)}/>
                </div>
            </div>
            <div className={"controls"}>
                <CustomerReviewSearchPeriod filter={filter} onSetFilter={onSetFilter} />

                {false && currency && !!currency.length && (<div className={"currency"}>
                    {currency.map(c => (
                        <div key={c} className={"currencyItem"}>{getCurrencyIcons(c)}</div>
                    ))}
                </div>)}
            </div>
        </div>
    );
}

export default CustomerSalesChartHeader;